import * as React from 'react';
import { Link } from 'react-router-dom';

import { ClickTracker } from 'bernie-analytics';
import { UitkIcon } from 'uitk-react-icons';
import { RouteStore } from 'bernie-core';
import { UitkLink } from 'uitk-react-link';

const LinkTracked = ClickTracker(Link);

interface AmenitiesLinkProps {
  amenitiesDialogRef: (HTMLElement) => void;
  iconId: string;
  linkText: string;
  linkClass?: string;
  linkName: string;
  routeStore?: RouteStore;
}

export const AmenitiesLink: React.FunctionComponent<AmenitiesLinkProps> = ({
  amenitiesDialogRef,
  iconId,
  linkClass = '',
  linkName,
  linkText,
  routeStore
}) => {
  const amenitiesDialogOpenQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialog: 'amenities' });

  return (
    <UitkLink className={linkClass}>
      <LinkTracked
        to={{ pathname: routeStore.pathname, search: amenitiesDialogOpenQuery }}
        innerRef={amenitiesDialogRef}
        rfrr=".ViewAllAmenities"
        linkName={linkName}
      >
        {linkText}
        <UitkIcon id={iconId} name="chevron_right" />
      </LinkTracked>
    </UitkLink>
  );
};
